(() => {
  const counters = () => document.querySelectorAll('.rich-text-counter[data-enable="true"]');

  const parseTarget = (raw) => {
    if (!raw) return null;
    const normalized = String(raw).replace(/,/g, '').trim();
    const value = Number.parseFloat(normalized);
    return Number.isFinite(value) ? value : null;
  };

  const formatValue = (value, decimals) => {
    if (decimals > 0) return value.toFixed(decimals);
    return Math.round(value).toString();
  };

  const animateCounter = (el) => {
    if (el.dataset.counted === 'true') return;

    const target = parseTarget(el.dataset.target);
    if (target === null) return;

    const duration = Number.parseInt(el.dataset.duration || '2000', 10);
    const decimals = Number.parseInt(el.dataset.decimals || '0', 10);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = formatValue(target, decimals);
      el.dataset.counted = 'true';
      return;
    }

    let startTime = null;

    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const current = target * progress;
      el.textContent = formatValue(current, decimals);

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = formatValue(target, decimals);
        el.dataset.counted = 'true';
      }
    };

    window.requestAnimationFrame(step);
  };

  const init = () => {
    const items = counters();
    if (!items.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.35 }
    );

    items.forEach((item) => observer.observe(item));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
